<panel class="no-padding table-panel">
  <div class="spinner" *ngIf="retrievingInspectionResults">
    <mat-spinner diameter="30"></mat-spinner>
  </div>
  <table class="table table--full-width table--striped table--hover table--sortable"
    *ngIf="!retrievingInspectionResults">
    <!-- <thead>
      <tr>
        <th (click)="sortBy('Eval')" style="text-align: center">{{'Evaluation' | translate | async}}</th>
        <th (click)="sortBy('InspectionDate')" width="130px">{{'Inspection Date' | translate | async}}</th>
        <th (click)="sortBy('Examiner')" width="130px">{{'Inspector' | translate | async}}</th>
        <th (click)="sortBy('SerialNumber')" width="130px">{{'Serial Number' | translate | async}}</th>
        <th (click)="sortBy('UnitNumber')" width="130px">{{'Unit Number' | translate | async}}</th>
        <th (click)="sortBy('AddiUnitNumber')" width="130px">{{'Additional Unit Number' | translate | async}}</th>
        <th (click)="sortBy('Customer')" width="130px">{{'Customer' | translate | async}}</th>
        <th (click)="sortBy('Jobsite')" width="130px">{{'Job Site' | translate | async}}</th>
        <th (click)="sortBy('Make')" width="100px">{{'Make' | translate | async}}</th>
        <th (click)="sortBy('Model')" width="100px">{{'Model' | translate | async}}</th>
        <th (click)="sortBy('Family')" width="130px">{{'Family' | translate | async}}</th>
        <th [attr.disabled] = "true" style="cursor: default;  " class="non-hover" width="130px">{{'Status' | translate | async}}</th>
        <th>
          <mat-checkbox  class="await-chkbox" style="margin-left: 0.1px;"    [(ngModel)]="checked"    (change)="loadAwaitInterpretations()" > {{'Awaiting Interpretation ' | translate | async}}   </mat-checkbox>
        </th>
        <th></th>
      </tr>
    </thead> -->
    <thead>
      <tr>
        <th (click)="sortBy('Eval')" width="100px">
          <span class="header-with-icon">
            {{'Evaluation' | translate | async}}
            <i class="material-icons sort-icon" *ngIf="evalOrder.selected">arrow_upward</i>
            <i class="material-icons sort-icon" *ngIf="!evalOrder.selected">arrow_downward</i>
          </span>
        </th>
        <th (click)="sortBy('InspectionDate')" >
          <span class="header-with-icon">
            {{'Inspection Date' | translate | async}}
            <i class="material-icons sort-icon" *ngIf="dateOrder.selected">arrow_upward</i>
            <i class="material-icons sort-icon" *ngIf="!dateOrder.selected">arrow_downward</i>
          </span>
        </th>
        <th (click)="sortBy('Examiner')" >
          <span class="header-with-icon">
            {{'Inspector' | translate | async}}
            <i class="material-icons sort-icon" *ngIf="examinerOrder.selected">arrow_upward</i>
            <i class="material-icons sort-icon" *ngIf="!examinerOrder.selected">arrow_downward</i>
          </span>
        </th>
        <th (click)="sortBy('SerialNumber')" >
          <span class="header-with-icon">
            {{'Serial Number' | translate | async}}
            <i class="material-icons sort-icon" *ngIf="serialOrder.selected">arrow_upward</i>
            <i class="material-icons sort-icon" *ngIf="!serialOrder.selected">arrow_downward</i>
          </span>
        </th>
        <th (click)="sortBy('UnitNumber')" >
          <span class="header-with-icon">
            {{'Unit Number' | translate | async}}
            <i class="material-icons sort-icon" *ngIf="uitOrder.selected">arrow_upward</i>
            <i class="material-icons sort-icon" *ngIf="!uitOrder.selected">arrow_downward</i>
          </span>
        </th>
        <th (click)="sortBy('AddiUnitNumber')">
          <span class="header-with-icon">
            {{'Additional Unit Number' | translate | async}}
            <i class="material-icons sort-icon" *ngIf="addiuitOrder.selected">arrow_upward</i>
            <i class="material-icons sort-icon" *ngIf="!addiuitOrder.selected">arrow_downward</i>
          </span>
        </th>
        <th (click)="sortBy('Customer')" >
          <span class="header-with-icon">
            {{'Customer' | translate | async}}
            <i class="material-icons sort-icon" *ngIf="customerOrder.selected">arrow_upward</i>
            <i class="material-icons sort-icon" *ngIf="!customerOrder.selected">arrow_downward</i>
          </span>
        </th>
        <th (click)="sortBy('Jobsite')" >
          <span class="header-with-icon">
            {{'Job Site' | translate | async}}
            <i class="material-icons sort-icon" *ngIf="jobsiteOrder.selected">arrow_upward</i>
            <i class="material-icons sort-icon" *ngIf="!jobsiteOrder.selected">arrow_downward</i>
          </span>
        </th>
        <th (click)="sortBy('Make')">
          <span class="header-with-icon">
            {{'Make' | translate | async}}
            <i class="material-icons sort-icon" *ngIf="makeOrder.selected">arrow_upward</i>
            <i class="material-icons sort-icon" *ngIf="!makeOrder.selected">arrow_downward</i>
          </span>
        </th>
        <th (click)="sortBy('Model')">
          <span class="header-with-icon">
            {{'Model' | translate | async}}
            <i class="material-icons sort-icon" *ngIf="modelOrder.selected">arrow_upward</i>
            <i class="material-icons sort-icon" *ngIf="!modelOrder.selected">arrow_downward</i>
          </span>
        </th>
        <th (click)="sortBy('Family')" >
          <span class="header-with-icon">
            {{'Family' | translate | async}}
            <i class="material-icons sort-icon" *ngIf="familyOrder.selected">arrow_upward</i>
            <i class="material-icons sort-icon" *ngIf="!familyOrder.selected">arrow_downward</i>
          </span>
        </th>
        <th class="status-th">
          <div class="status-flex">
            <span class="status-header">
              {{ 'Status' | translate | async }}
            </span>
            <mat-checkbox
              class="await-chkbox"
              [(ngModel)]="checked"
              (change)="loadAwaitInterpretations()">
              {{ 'Awaiting Interpretation' | translate | async }}
            </mat-checkbox>
          </div>
        </th>
        <!-- <th class="status-th">
          <div class="status-header">
            {{ 'Status' | translate | async }}
          </div>
          <mat-checkbox
            class="await-chkbox"
            [(ngModel)]="checked"
            (change)="loadAwaitInterpretations()">
            {{ 'Awaiting Interpretation' | translate | async }}
          </mat-checkbox>
        </th> -->
        <!-- <th [attr.disabled]="true" style="cursor: default;" class="non-hover" width="130px">
          {{'Status' | translate | async}}
        </th>
        <th>
          <mat-checkbox class="await-chkbox" style="margin-left: 0.1px;" [(ngModel)]="checked"
            (change)="loadAwaitInterpretations()">
            {{'Awaiting Interpretation' | translate | async}}
          </mat-checkbox>
        </th> -->
        <th width="50px"></th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let inspection of inspectionResults">
        <td width="100px" class="no-padding" (click)="openInspection(i)" [@fadeIn] style="text-align: center">
          <span class="eval eval--{{inspection.Evaluation | lowercase}}">{{inspection.Evaluation}}</span>
        </td>
        <td  (click)="openInspection(inspection)" [@fadeIn]>{{inspection.InspectionDate |
          date:'dd/MMM/yyyy'}}</td>
        <td  (click)="openInspection(inspection)" [@fadeIn] [attr.title]="inspection.Examiner">
          {{inspection.Examiner}}</td>
        <td  (click)="openInspection(inspection)" [@fadeIn] [attr.title]="inspection.SerialNumber">
          {{inspection.SerialNumber }}</td>
        <td  (click)="openInspection(inspection)" [@fadeIn] [attr.title]="inspection.UnitNumber">
          {{inspection.UnitNumber }}</td>
        <td  (click)="openInspection(inspection)" [@fadeIn] [attr.title]="inspection.AddiUnitNumber">
          {{inspection.AddiUnitNumber }}</td>
        <td  (click)="openInspection(inspection)" [@fadeIn] [attr.title]="inspection.CustomerName">
          {{inspection.CustomerName }}</td>
        <td  (click)="openInspection(inspection)" [@fadeIn] [attr.title]="inspection.JobsiteName">
          {{inspection.JobsiteName }}</td>
        <td  (click)="openInspection(inspection)" [@fadeIn] [attr.title]="inspection.Make">
          {{inspection.Make }}</td>
        <td  (click)="openInspection(inspection)" [@fadeIn] [attr.title]="inspection.Model">
          {{inspection.Model }}</td>
        <td  (click)="openInspection(inspection)" [@fadeIn] [attr.title]="inspection.Family">
          {{inspection.Family}}</td>
        <td (click)="openInspection(inspection)" [@fadeIn]>
          <span class="status status--{{inspection.Status | lowercase}}">
            {{inspection.Status | translate | async}}
          </span>
        </td>
        <td >
          <!-- <i *ngIf="inspection.IsFlagged==false" class="material-icons" style="font:rgb(163, 154, 154)" >flag</i> -->
          <i *ngIf="inspection.IsFlagged" class="material-icons" style="color: red;">flag</i>
        </td>
      </tr>
      <!-- <inspection-list-row *ngFor="let i of inspectionResults" [inspectionId]="i"></inspection-list-row> -->
    </tbody>
  </table>
  <mat-paginator [pageIndex]="pageNumber" [length]="totalResults" [pageSize]="inspectionsPerPage" [pageSizeOptions]="[5, 10, 25, 100]" (page)="onPageEvent($event)">
  </mat-paginator>
</panel>